import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { clearCurrentOrder } from 'src/redux/action/currentOrder.action';
interface PrivateRouteProps {
  route: any | undefined;
  shiftData: boolean | null;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ route, shiftData }) => {
  const token = window.localStorage.getItem('accessToken');
  const roleItem = window.localStorage.getItem('role');
  const userRole = roleItem ? JSON.parse(roleItem) : null;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (route === '/kitchen-display') return;
    if (!token) {
      return navigate('/login');
    } else {
      if (route.adminOnly) {
        dispatch(clearCurrentOrder());
      }
      if (route.adminOnly && userRole && userRole !== 'admin') {
        navigate('/dine-in');
      }
    }
  }, [token, shiftData, route, userRole, navigate, dispatch]);

  return token ? <Outlet /> : null;
};

export default React.memo(PrivateRoute);
